const VARIANTS = [
  {
    title: 'Мангал под навесом',
    desc: 'Классический вариант: кирпичный или металлический мангал под крышей. Защита от дождя и солнца, дымоход — всё просто и надёжно.',
    specs: 'Базовая комплектация',
    imageUrl: 'https://readdy.ai/api/search-image?query=Brick%20barbecue%20grill%20under%20dark%20metal%20roof%20canopy%20with%20chimney%20outdoor%20setting%20garden%20backyard%20daytime%20natural%20lighting%20simple%20functional%20design%20warm%20tones%20realistic%20architectural%20photography%20clean%20composition&width=800&height=600&seq=var-bbq-canopy&orientation=landscape',
  },
  {
    title: 'Барбекю-комплекс',
    desc: 'Полноценный комплекс: мангал, коптильня, вертел, разделочная поверхность. Для тех, кто подходит к готовке на огне серьёзно.',
    specs: 'Расширенная комплектация',
    imageUrl: 'https://readdy.ai/api/search-image?query=Complete%20outdoor%20BBQ%20complex%20with%20builtin%20grill%20smoker%20rotisserie%20and%20prep%20counter%20under%20metal%20roof%20canopy%20brick%20and%20steel%20construction%20garden%20setting%20daytime%20natural%20lighting%20professional%20cooking%20setup%20realistic%20architectural%20photography%20clean%20composition&width=800&height=600&seq=var-bbq-complex&orientation=landscape',
  },
  {
    title: 'Зона с печью и казаном',
    desc: 'Русская печь или тандыр плюс место под казан. Для ценителей плова, шурпы и выпечки — аутентичная готовка на участке.',
    specs: 'С печью и казаном',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20cooking%20zone%20with%20traditional%20clay%20oven%20tandoor%20and%20builtin%20cauldron%20stand%20under%20metal%20canopy%20brick%20construction%20garden%20setting%20daytime%20natural%20lighting%20rustic%20authentic%20design%20warm%20earthy%20tones%20realistic%20architectural%20photography%20clean%20composition&width=800&height=600&seq=var-bbq-oven&orientation=landscape',
  },
  {
    title: 'С мойкой и столешницей',
    desc: 'Мангальная зона с водопроводом: мойка, столешница, ящики для посуды и специй. Удобно как на кухне, только на свежем воздухе.',
    specs: 'С водопроводом',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20BBQ%20zone%20with%20builtin%20sink%20countertop%20and%20storage%20drawers%20under%20metal%20roof%20canopy%20brick%20and%20steel%20construction%20garden%20setting%20daytime%20natural%20lighting%20modern%20functional%20design%20with%20running%20water%20realistic%20architectural%20photography%20clean%20composition&width=800&height=600&seq=var-bbq-sink&orientation=landscape',
  },
  {
    title: 'С дровником',
    desc: 'Встроенный дровник на 1–2 куба дров. Всегда сухие дрова под рукой, аккуратный внешний вид, никаких куч на участке.',
    specs: 'Со встроенным дровником',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20BBQ%20zone%20with%20builtin%20firewood%20storage%20compartment%20neatly%20stacked%20logs%20under%20metal%20roof%20canopy%20brick%20and%20steel%20construction%20garden%20setting%20daytime%20natural%20lighting%20practical%20organized%20design%20warm%20tones%20realistic%20architectural%20photography%20clean%20composition&width=800&height=600&seq=var-bbq-firewood&orientation=landscape',
  },
];

const WHATSAPP_MSG = encodeURIComponent('Здравствуйте! Хочу рассчитать стоимость мангальной зоны. Интересует вариант: ');

export default function VariantsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Варианты исполнения
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Пять популярных решений — от&nbsp;простого мангала под&nbsp;навесом до&nbsp;полноценной летней&nbsp;кухни
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {VARIANTS.map((variant, idx) => (
            <div
              key={variant.title}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-400 hover:border-primary-200/50 flex flex-col animate-fade-in-up"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <div className="relative w-full h-52 md:h-60 overflow-hidden shrink-0">
                <img
                  src={variant.imageUrl}
                  alt={variant.title}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{variant.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 flex-1">{variant.desc}</p>
                <p className="text-xs font-medium text-accent-600 mb-4 bg-accent-100 inline-block self-start px-2.5 py-1 rounded-full">{variant.specs}</p>
                <a
                  href={`https://wa.me/79174131562?text=${WHATSAPP_MSG}${encodeURIComponent(variant.title.toLowerCase() + '.')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-5 py-2.5 rounded-md transition-all duration-300 cursor-pointer text-center"
                >
                  Узнать стоимость
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}